export default __webpack_public_path__ + "static/media/les_andelys09.28335dec.jpg";